import { use } from "react";
import { useMutation } from "@tanstack/react-query";
import { useDbClient } from "@tanstack/react-db";
import { QueryViewerContext } from "@softmax/web-features/data";
import { playerMutationOptions } from "./player.mutations";

export function usePlayerMutation({
  elevatedPrivileges,
}: {
  elevatedPrivileges: boolean;
}) {
  const dbClient = useDbClient();
  const viewerId = use(QueryViewerContext);
  return useMutation(
    playerMutationOptions({ dbClient, viewerId, elevatedPrivileges }),
  );
}
